export const defaultSet = {
  id: 0,
  fields: [],
}
